<template>
  <div class="page_404">
    <div class="item">
      <img src="./404.png">
      <div class="tips">
        <p>
          404没有找到该页面...
        </p>
        <div v-if="redirectedFrom" class="from_url">
          {{redirectedFrom}}
        </div>
        <el-button size="medium" @click="handleReturn">返回系统</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error_404',
  data() {
    return {
      redirectedFrom: ''
    }
  },
  created() {
    if (!this.$route.redirectedFrom) return;
    this.redirectedFrom = this.$route.redirectedFrom;
  },
  methods: {
    handleReturn() {
      this.$router.push({
        path: '/'
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page_404 {
  height: 100%;
  background-color: $bg-color-base;
  text-align: center;
  font-size: 24px;

  div.item {
    text-align: center;
    width: 578px;
    margin: 0 auto;
    margin-top: 150px;

    img {
      width: 214px;
    }

    div.tips {
      font-size: 20px;
      color: $text-primary;
      height: 278px;

      .el-button {
        margin-top: 20px;
      }
    }
  }

  div.from_url {
    font-size: 12px;
    padding-top: 10px;
    word-break: break-word;
  }
}
</style>
